type MatomoEventValue = string | number

export function trackMatomoEvent(
  category: string,
  action: string,
  name?: string,
  value?: number,
) {
  if (typeof window === 'undefined') return

  window._paq = window._paq || []

  const event: MatomoEventValue[] = ['trackEvent', category, action]
  if (name !== undefined) event.push(name)
  if (value !== undefined) event.push(value)

  window._paq.push(event)
}
